<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <form @submit.stop>
      <div class="breadcrumb-area pos-relative w-100">
        <h1>{{ dataRequest.id ? 'Sửa' : 'Tạo ' }} phiếu đăng ký ưu đãi</h1>
        <div style="float: right">
          <button
            type="button"
            @click="previousStepOne()"
            class="btn btn-light"
            v-if="step == 2 && !dataRequest.id"
          >
            Quay lại
          </button>

          <button
            type="button"
            @click="$router.push('/preferential-merchant-registration')"
            class="btn btn-light ml-2"
          >
            Hủy
          </button>

          <button
            type="button"
            class="btn btn-light ml-2"
            @click="submitRequestStepOne()"
            v-if="step == 1"
          >
            Tiếp tục
          </button>

          <button
            type="button"
            class="btn btn-light ml-2"
            @click="submitRequestStepTwo()"
            v-if="step == 2"
          >
            Lưu
          </button>
        </div>
      </div>

      <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
        <div class="card-body px-20 row">
          <div class="col-md-6">
            <div class="m-b-10" style="border: 1px solid"></div>
            <div v-if="dataRequest.id && dataRequest.id != ''">
              <TicketInfo ref="ticketInfoRef" />
            </div>
            <div v-else>
              <h6>Thông tin phiếu</h6>
              <ValidationProvider
                rules="required"
                vid="typeOffer"
                name="Loại ưu đãi"
                :persist="true"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Loại ưu đãi<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      v-model="dataRequest.typeOffer"
                      :options="optionType"
                      :disabled="step != 1"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="merchantName" name="Merchant">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Merchant <span style="color: red">*</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      type="hidden"
                      class="form-control text-left"
                      v-model="dataRequest.merchantMposId"
                    />
                    <input
                      type="text"
                      class="form-control text-left"
                      :value="
                        merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''
                      "
                      readonly
                      placeholder="Chọn merchant"
                      v-b-modal.select-merchant-dialog
                      :disabled="step != 1"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div v-if="step == 2 && dataRequest.merchantMposId">
              <div class="m-b-10" style="border: 1px solid"></div>
              <div>
                <h6>Điều kiện MC key</h6>
                <ValidationProvider
                  rules="required"
                  vid="industry"
                  name="Ngành nghề"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Ngành nghề<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.industry"
                        :options="systemConfig.businessFields"
                        @change="selectedBusiness"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="detailedIndustry"
                  name="NN chi tiết"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      NN chi tiết<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.detailedIndustry"
                        :options="optionBusinessDetail"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="otherDetailedIndustry"
                  name="NN chi tiết (khác)"
                  :persist="true"
                  v-if="dataRequest.detailedIndustry == 'Khác'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      NN chi tiết (khác)<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="dataRequest.otherDetailedIndustry"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="revenue" name="Doanh số" :persist="true">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Doanh số<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="dataRequest.revenue"
                        @input="updateRevenue"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="numberOfStore"
                  name="Số cửa hàng"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Số cửa hàng<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataRequest.numberOfStore"
                        @input="updateNumberOfStore"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="note_1000"
                  vid="mcKeyNote"
                  name="Ghi chú LQ MC Key"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label">Ghi chú LQ MC Key</label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        v-model.trim="dataRequest.mcKeyNote"
                        placeholder="Nhập thông tin ghi chú LQ MC Key"
                        rows="3"
                        style="resize: none"
                      ></textarea>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="m-b-10" style="border: 1px solid"></div>
              <div>
                <h6>Hồ sơ chính</h6>
                <ValidationProvider
                  rules="required"
                  vid="businessForm"
                  name="Hình thức KD"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Hình thức KD<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.businessForm"
                        :options="systemConfig.businessField"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="brand" name="Thương hiệu" :persist="true">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Thương hiệu<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="dataRequest.brand" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="brandOwnership"
                  name="Sở hữu thương hiệu"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Sở hữu thương hiệu<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.brandOwnership"
                        :options="optionBrandOwnerShip"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="bankAccountType"
                  name="Loại tài khoản ngân hàng"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Loại tài khoản ngân hàng<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.bankAccountType"
                        :options="optionBankAccountType"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="websiteLink"
                  name="Link website"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Link website<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="dataRequest.websiteLink" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="note_1000"
                  vid="mainProfileNote"
                  name="Ghi chú LQ HS chính"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label">Ghi chú LQ HS chính</label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        v-model.trim="dataRequest.mainProfileNote"
                        placeholder="Nhập thông tin ghi chú LQ HS chính"
                        rows="3"
                        style="resize: none"
                      ></textarea>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="" vid="" name="Link hợp đồng" :persist="true">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label">Link hợp đồng</label>
                    <div class="col-sm-9">
                      <b-button @click.prevent="openLinkContract">Xem hợp đồng</b-button>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="idCardImage"
                  name="Ảnh CCCD"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ảnh CCCD<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="hidden" v-model="dataRequest.idCardImage" />
                      <UploadMultiple
                        @syncFile="syncFileIdCardImage"
                        :lsData="idCardImage"
                        :maxFile="20"
                        uniqueKey="images"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="businessLicenseImage"
                  name="Ảnh ĐKKD"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ảnh ĐKKD<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="hidden" v-model="dataRequest.businessLicenseImage" />
                      <UploadMultiple
                        @syncFile="syncFileBusinessLicenseImage"
                        :lsData="businessLicenseImage"
                        :maxFile="20"
                        uniqueKey="images"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="brandRelatedImage"
                  name="Ảnh LQ thương hiệu"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Ảnh LQ thương hiệu<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="hidden" v-model="dataRequest.brandRelatedImage" />
                      <UploadMultiple
                        @syncFile="syncFileBrandRelatedImage"
                        :lsData="brandRelatedImage"
                        :maxFile="20"
                        uniqueKey="images"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="operatingLicense"
                  name="GP hoạt động"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >GP hoạt động<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="hidden" v-model="dataRequest.operatingLicense" />
                      <UploadMultiple
                        @syncFile="syncFileOperatingLicense"
                        :lsData="operatingLicense"
                        :maxFile="20"
                        uniqueKey="images"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="salesInvoiceImage"
                  name="Hóa đơn bán hàng"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Hóa đơn bán hàng<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="hidden" v-model="dataRequest.salesInvoiceImage" />
                      <UploadMultiple
                        @syncFile="syncFileSalesInvoiceImage"
                        :lsData="salesInvoiceImage"
                        :maxFile="20"
                        uniqueKey="images"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div>
                <div class="d-flex justify-content-between">
                  <h6>Danh sách cửa hàng</h6>
                  <span class="fonsize-20" style="cursor: pointer" @click="addBusinessStore"
                    >+</span
                  >
                </div>
                <div
                  v-for="(item, index) in dataRequest.businessAddress"
                  v-if="dataRequest.businessAddress.length > 0"
                >
                  <div class="m-b-10" style="border: 1px solid; padding: 8px" :key="index">
                    <div class="m-b-10" style="display: flex">
                      <span class="mr-auto">ĐCNTT</span>
                      <span style="cursor: pointer" @click="deleteBusinessStore(index)">X</span>
                    </div>
                    <ValidationProvider
                      rules="required"
                      :vid="`name-${index}`"
                      name="Tên cửa hàng"
                      :persist="true"
                    >
                      <div class="form-group row" slot-scope="{ errors }">
                        <label class="col-sm-3 col-form-label">
                          Tên cửa hàng<span style="color: red"> *</span>
                        </label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            v-model="dataRequest.businessAddress[index].name"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      rules="required"
                      :vid="`address-${index}`"
                      name="Địa chỉ"
                      :persist="true"
                    >
                      <div class="form-group row" slot-scope="{ errors }">
                        <label class="col-sm-3 col-form-label">
                          Địa chỉ<span style="color: red"> *</span>
                        </label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            v-model="dataRequest.businessAddress[index].address"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      rules="required"
                      :vid="`provinceId-${index}`"
                      name="Tỉnh thành"
                    >
                      <div class="form-group row" slot-scope="{ errors }">
                        <label class="col-sm-3 col-form-label">
                          Tỉnh thành<span style="color: red"> *</span>
                        </label>
                        <div class="col-sm-9">
                          <Select2
                            v-model="dataRequest.businessAddress[index].provinceId"
                            @change="getDistrict($event, index)"
                            :options="dataCity"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      rules="required"
                      :vid="`districtId-${index}`"
                      name="Quận huyện"
                      :persist="true"
                    >
                      <div class="form-group row" slot-scope="{ errors }">
                        <label class="col-sm-3 col-form-label">
                          Quận huyện<span style="color: red"> *</span>
                        </label>
                        <div class="col-sm-9">
                          <Select2
                            v-model="dataRequest.businessAddress[index].districtId"
                            :options="getDistrictOptions(index)"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="" vid="" name="Ảnh liên quan" :persist="true">
                      <div class="form-group row" slot-scope="{ errors }">
                        <label for="" class="col-sm-3 col-form-label">Ảnh liên quan</label>
                        <div class="col-sm-9">
                          <div class="form-group img-list">
                            <UploadMultiple
                              @syncFile="
                                (fileUploads, uniqueKey) =>
                                  syncFileRelatedImage(fileUploads, uniqueKey, index)
                              "
                              :lsData="dataRequest.businessAddress[index].images"
                              :maxFile="20"
                              uniqueKey="images"
                            />
                          </div>
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div
                class="m-b-10 m-t-20"
                style="border: 1px solid"
                v-if="dataRequest.typeOffer == 'MC_KEY_ONUS'"
              ></div>
              <div v-if="dataRequest.typeOffer == 'MC_KEY_ONUS'">
                <h6>Đăng ký ON-US</h6>
                <ValidationProvider
                  rules="required"
                  vid="bankRegisteredWithONUS"
                  name="Bank ĐK ON-US"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Bank ĐK ON-US<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2MultipleControl
                        :settings="{ closeOnSelect: false }"
                        v-model="dataRequest.bankRegisteredWithONUS"
                        :options="systemConfig.posBankIssuer"
                      >
                      </Select2MultipleControl>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="note_1000"
                  vid="onusNote"
                  name="Ghi chú LQ ON-US"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label">Ghi chú LQ ON-US:</label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        v-model.trim="dataRequest.onusNote"
                        placeholder="Nhập thông tin ghi chú LQ ON-US"
                        rows="3"
                        style="resize: none"
                      ></textarea>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="m-b-10 m-t-20" style="border: 1px solid"></div>
              <div>
                <h6>Cam kết bổ sung</h6>
                <ValidationProvider
                  rules="required"
                  vid="additionalStatus"
                  name="Trạng thái bổ sung"
                  :persist="true"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Trạng thái bổ sung<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        v-model="dataRequest.additionalStatus"
                        :options="optionAdditionalStatus"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <div v-if="dataRequest.additionalStatus == 'NEED_ADDITIONAL_INFO_LATER'">
                  <ValidationProvider
                    rules="required"
                    vid="informAt.startDate"
                    name="Thời gian bổ sung"
                    :persist="true"
                  >
                    <div class="form-group row" slot-scope="{ errors }">
                      <label class="col-sm-3 col-form-label">
                        Thời gian bổ sung<span style="color: red"> *</span>
                      </label>
                      <div class="col-sm-9">
                        <DateRangePicker
                          class="w-100"
                          :ranges="false"
                          :show-week-numbers="false"
                          :single-date-picker="true"
                          v-model="dataRequest.informAt"
                          :locale-data="Config.localeData"
                          :timePicker="false"
                          :timePicker24Hour="false"
                        >
                          <template v-slot:input="picker">
                            {{ picker.startDate | formatDate }}
                          </template>
                        </DateRangePicker>
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    rules="required|note_1000"
                    vid="additionalCommitmentNote"
                    name="Ghi chú cam kết bổ sung sau"
                    :persist="true"
                  >
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-3 col-form-label"
                        >Ghi chú cam kết bổ sung sau <span style="color: red"> *</span></label
                      >
                      <div class="col-sm-9">
                        <textarea
                          class="form-control"
                          v-model.trim="dataRequest.additionalCommitmentNote"
                          placeholder="Nhập thông tin ghi chú cam kết bổ sung sau"
                          rows="3"
                          style="resize: none"
                        ></textarea>
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    rules=""
                    vid="additionalImg"
                    name="Ảnh BS cam kết"
                    :persist="true"
                  >
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-3 col-form-label">Ảnh BS cam kết</label>
                      <div class="col-sm-9">
                        <UploadMultiple
                          @syncFile="syncFileAdditionalImg"
                          :lsData="additionalImg"
                          :maxFile="20"
                          uniqueKey="images"
                        />
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div
              v-if="
                step == 2 && dataRequest.merchantMposId && dataRequest.id && dataRequest.id != ''
              "
            >
              <div class="m-b-10" style="border: 1px solid"></div>
              <div class="form-group">
                <h6>Ghi chú duyệt</h6>
                <div class="form-group row">
                  <label for="" class="col-sm-3">Ghi chú của VH</label>
                  <div class="col-sm-9">
                    <span>{{ dataRequest.operationNote }}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-sm-3">Ghi chú của GĐV</label>
                  <div class="col-sm-9">
                    <span>{{ dataRequest.regionDirectorNote }}</span>
                  </div>
                </div>
              </div>
              <div class="m-b-10" style="border: 1px solid"></div>
              <HistoryAction ref="historyActionRef" />
            </div>
          </div>
        </div>
      </div>
    </form>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <SelectMerchant @selectMerchant="onSelectMerchant" />
  </ValidationObserver>
</template>
<script>
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import Config from '@/thirdParty/config'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import { CommonService } from '@/services/common.service'
  import { StaffService } from '@/services/staff.service'
  import cloneDeep from 'lodash/cloneDeep'
  import moment from 'moment'
  import { ContractService } from '@/services/contract.service'
  import { MerchantService } from '@/services/merchant.service'
  import HistoryAction from './component/historyAction.vue'
  import TicketInfo from './component/ticketInfo.vue'

  export default {
    components: { UploadMultiple, SelectMerchant, HistoryAction, TicketInfo },
    data() {
      return {
        step: this.$route.query.step ?? 1,
        Config,
        dataRequest: {
          id: this.$route.params.id ?? '',
          informAt: {},
          merchantMposId: '',
          additionalStatus: 'NO_ADDITIONAL_INFO_NEEDED',
          businessAddress: [],
        },
        showLoading: false,
        fileUploads: [],
        dataCity: [],
        dataDistrict: [],
        merchantSelected: {
          merchantName: '',
        },
        optionType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_KEY_ONUS', text: 'Merchant key + onus' },
        ],
        systemConfig: {
          baseMccDetail: [],
          businessFields: [],
          businessField: [],
          baseMccDetail: [],
        },
        optionAdditionalStatus: [
          { id: 'NO_ADDITIONAL_INFO_NEEDED', text: 'Không cần bổ sung' },
          { id: 'NEED_ADDITIONAL_INFO_LATER', text: 'Cần bổ sung sau' },
        ],
        optionBusinessDetail: [],
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'AWAITING_MANAGER_APPROVAL', text: 'Chờ GĐV duyệt' },
          { id: 'MANAGER_REJECTED', text: 'Từ chối' },
          { id: 'MANAGER_REQUESTED_ADDITIONAL', text: 'GĐV YC Bổ sung' },
          { id: 'AWAITING_OPERATION_APPROVAL', text: 'Chờ VH duyệt' },
          { id: 'OPERATION_REQUESTED_EDIT', text: 'VH yêu cầu bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'VH đã duyệt' },
          { id: 'CANCELED', text: 'Đã huỷ' },
        ],
        optionStatusCanEdit: ['NEW', 'MANAGER_REQUESTED_ADDITIONAL', 'OPERATION_REQUESTED_EDIT'],
        optionBankAccountType: Config.mcBankAccType,
        optionBrandOwnerShip: Config.mcKeyOwnerType,
        contractHistoryOne: {},
        checkGetDistrict: false,

        idCardImage: [], // Ảnh căn cước công dân
        businessLicenseImage: [], // Ảnh đăng ký kinh doanh
        brandRelatedImage: [], // Ảnh liên quan thương hiệu
        operatingLicense: [], // Giấy phép hoạt động
        salesInvoiceImage: [], // Ảnh hoá đơn bán hàng
        relatedImage: [], // Ảnh liên quan
        additionalImg: [], // Ảnh BS cam kết
      }
    },
    watch: {},
    async created() {
      await this.getCity()
      await this.getConfigSystem()
      await this.fetchData()
      await this.fetchDataMerchantStepTwo()
    },
    async mounted() {},
    computed: {
      mapData() {
        return (option, id = 'code', text = 'name') => {
          return option.map(e => ({ id: e[id], text: e[text] }))
        }
      },
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      formatNumberString() {
        return value => {
          const stringNum = value.toString()

          // Loại bỏ các ký tự không phải số
          let numericValue = stringNum.replace(/\D/g, '')

          // Loại bỏ các dấu chấm dẫn đầu
          numericValue = numericValue.replace(/^0+/, '')

          // Thêm dấu chấm vào số
          numericValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

          // Loại bỏ các chữ số dư thừa sau dấu chấm
          const parts = numericValue.split('.')
          if (parts.length > 1 && parts[1].length > 3) {
            numericValue = parts[0] + '.' + parts[1].slice(0, 3)
          }

          return numericValue
        }
      },
      formatNumber() {
        return value => {
          const stringNum = value.toString()

          // Loại bỏ các ký tự không phải số ở đầu và cuối chuỗi
          const numericValue = stringNum.replace(/^\D+|\D+$/g, '')

          return numericValue
        }
      },
      getDistrictOptions() {
        return index => {
          if (this.checkGetDistrict) {
            const provinceId = this.dataRequest.businessAddress[index].provinceId ?? ''
            if (provinceId != '') {
              return this.dataDistrict[provinceId] ?? []
            }
          }
          return []
        }
      },
    },
    methods: {
      async submitRequestStepOne() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        this.step = 2
        this.$router.replace({
          path: `/preferential-merchant-registration/create?step=${this.step}&typeOffer=${this.dataRequest.typeOffer}&merchantId=${this.merchantSelected.customerId}`,
        })
      },
      previousStepOne() {
        this.step = 1
        this.$router.replace({
          path: `/preferential-merchant-registration/create?step=${this.step}`,
        })
        this.resetData()
      },
      async submitRequestStepTwo() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return

        if (!this.dataRequest.merchantMposId || this.dataRequest.merchantMposId == '')
          return this.showFailMx('Đây không phải merchant MPOS')

        if (this.dataRequest.businessAddress.length != this.relatedImage.length)
          return this.showFailMx('Ảnh liên quan trong danh sách cửa hàng không được để trống')

        if (this.dataRequest.businessAddress.length === 0 && this.relatedImage.length === 0)
          return this.showFailMx('Danh sách cửa hàng không được để trống')

        if (this.dataRequest.id) {
          await this.update()
        } else {
          await this.create()
        }
      },
      async create() {
        try {
          this.showLoading = true

          const params = await this.prepareDataStepTwo()
          if (params.message) {
            this.showFailMx(params.message)
            return
          }

          const response = await ContractService.createMerchantKeyOnus(params)

          if (response.success) {
            const mapData = response.data
            if (mapData.data) {
              this.dataRequest.id = mapData.data.id
              this.showSuccessMx('Tạo phiếu đăng ký ưu đãi thành công').then(() =>
                this.$router.push(`/preferential-merchant-registration/detail/${mapData.data.id}`)
              )
            } else {
              this.showFailMx('Không có thông tin dữ liệu trả về')
            }
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async update() {
        try {
          this.showLoading = true

          const params = await this.prepareDataStepTwo()
          if (params.message) {
            this.showFailMx(params.message)
            return
          }

          const response = await ContractService.updateMerchantKeyOnus(params)
          if (response.success) {
            this.showSuccessMx('Cập nhật phiếu đăng ký ưu đãi thành công').then(() =>
              this.$router.push(`/preferential-merchant-registration/detail/${this.dataRequest.id}`)
            )
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async prepareDataStepTwo() {
        const params = cloneDeep(this.dataRequest)

        params.merchantId = this.merchantSelected.customerId ? this.merchantSelected.customerId : ''
        params.merchantEmail = this.merchantSelected.email ? this.merchantSelected.email : ''

        const files = {
          idCardFiles: await Promise.all(this.idCardImage.map(s => this.sendFile(s))).catch(e => {
            return []
          }), // Ảnh căn cước công dân
          businessLicenseFiles: await Promise.all(
            this.businessLicenseImage.map(s => this.sendFile(s))
          ).catch(e => {
            return []
          }), // Ảnh đăng ký kinh doanh
          brandRelatedFiles: await Promise.all(
            this.brandRelatedImage.map(s => this.sendFile(s))
          ).catch(e => {
            return []
          }), // Ảnh liên quan thương hiệu
          operatingLicenseFiles: await Promise.all(
            this.operatingLicense.map(s => this.sendFile(s))
          ).catch(e => {
            return []
          }), // Giấy phép hoạt động
          salesInvoiceFiles: await Promise.all(
            this.salesInvoiceImage.map(s => this.sendFile(s))
          ).catch(e => {
            return []
          }), // Ảnh hoá đơn bán hàng
        }

        if (
          files.idCardFiles.length == 0 ||
          files.businessLicenseFiles.length == 0 ||
          files.brandRelatedFiles.length == 0 ||
          files.operatingLicenseFiles.length == 0 ||
          files.salesInvoiceFiles.length == 0
        ) {
          return { message: 'Có lỗi xảy ra trong quá trình upload ảnh' }
        }

        if (this.dataRequest.additionalStatus == 'NEED_ADDITIONAL_INFO_LATER') {
          if (this.additionalImg.length > 0) {
            const additionalFiles = await Promise.all(
              this.additionalImg.map(s => this.sendFile(s))
            ).catch(e => {
              return []
            })
            if (additionalFiles.length == 0) {
              return { message: 'Có lỗi xảy ra trong quá trình upload ảnh' }
            }
            params.additionalImg = additionalFiles.map(s => s.urlFile) // Ảnh BS cam kết
          }

          params.additionalTime = moment(params.informAt.startDate)
        }

        if (this.relatedImage.length > 0) {
          let flag = false
          const relatedImage = {}

          await Promise.all(
            this.relatedImage.map(async (item, index) => {
              const mapData = await Promise.all(item.map(s => this.sendFile(s))).catch(e => {
                return []
              }) // Ảnh liên quan
              if (mapData.length == 0) {
                flag = true
              }
              relatedImage[index] = mapData
            })
          )

          if (flag) {
            return { message: 'Có lỗi xảy ra trong quá trình upload ảnh' }
          }

          params.businessAddress.map((item, index) => {
            if (relatedImage[index]) {
              item.images = relatedImage[index].reduce((acc, current) => {
                acc.push(current.urlFile)
                return acc
              }, [])
            }
          })
        }

        params.idCardImage = files.idCardFiles.map(s => s.urlFile)
        params.businessLicenseImage = files.businessLicenseFiles.map(s => s.urlFile)
        params.brandRelatedImage = files.brandRelatedFiles.map(s => s.urlFile)
        params.operatingLicense = files.operatingLicenseFiles.map(s => s.urlFile)
        params.salesInvoiceImage = files.salesInvoiceFiles.map(s => s.urlFile)

        params.revenue = params.revenue ? params.revenue.toString().replace(/\./g, '') : 0

        if (params.id == '') {
          delete params.id
        }

        return params
      },
      async fetchData() {
        if (this.dataRequest.id) {
          try {
            this.showLoading = true
            const response = await ContractService.detailMerchantKeyOnus({
              id: this.dataRequest.id,
            })
            if (response.success) {
              const mapData = response.data
              if (mapData.data) {
                this.merchantSelected = mapData.data.merchant ? mapData.data.merchant : {}
                this.merchantSelected.customerId =
                  mapData.data.merchant && mapData.data.merchant.id ? mapData.data.merchant.id : ''
                if (!this.optionStatusCanEdit.includes(mapData.data.status)) {
                  this.showFailMx('Trạng thái không hợp lệ')
                  this.$router.push(`/preferential-merchant-registration`)
                  return
                }
                await this.onSelectMerchant(mapData.data.merchant)
                this.step = 2
                this.dataRequest.informAt = mapData.data.additionalTime
                  ? {
                      startDate: moment(mapData.data.additionalTime).valueOf(),
                      endDate: moment(mapData.data.additionalTime).valueOf(),
                    }
                  : {}
                this.dataRequest.additionalCommitmentNote =
                  mapData.data.additionalCommitmentNote ?? ''
                this.dataRequest.additionalImg = mapData.data.additionalImg ?? []
                this.additionalImg = mapData.data.additionalImg ?? []
                this.dataRequest.additionalStatus = mapData.data.additionalStatus ?? ''
                this.dataRequest.bankRegisteredWithONUS = mapData.data.bankRegisteredWithONUS ?? []
                this.dataRequest.brand = mapData.data.brand ?? ''
                this.dataRequest.brandRelatedImage = mapData.data.brandRelatedImage ?? []
                this.brandRelatedImage = this.dataRequest.brandRelatedImage ?? []
                if (mapData.data.businessAddress && mapData.data.businessAddress.length > 0) {
                  this.relatedImage = []
                  this.dataRequest.businessAddress = await mapData.data.businessAddress.reduce(
                    async (acc, current) => {
                      await this.getDistrict(current.provinceId)

                      if (current.images.length > 0) {
                        this.relatedImage.push(current.images)
                      }

                      ;(await acc).push(current)

                      return acc
                    },
                    []
                  )
                }
                this.dataRequest.businessForm = mapData.data.businessForm ?? ''
                this.dataRequest.businessLicenseImage = mapData.data.businessLicenseImage ?? []
                this.businessLicenseImage = this.dataRequest.businessLicenseImage ?? []
                this.dataRequest.detailedIndustry = mapData.data.detailedIndustry ?? ''
                this.dataRequest.idCardImage = mapData.data.idCardImage ?? []
                this.idCardImage = mapData.data.idCardImage ?? []
                this.dataRequest.industry = mapData.data.industry ?? ''
                await this.selectedBusiness()
                this.dataRequest.mainProfileNote = mapData.data.mainProfileNote ?? ''
                this.dataRequest.mcKeyNote = mapData.data.mcKeyNote ?? ''
                this.dataRequest.numberOfStore = mapData.data.numberOfStore ?? ''
                this.dataRequest.onusNote = mapData.data.onusNote ?? ''
                this.dataRequest.operatingLicense = mapData.data.operatingLicense ?? []
                this.operatingLicense = mapData.data.operatingLicense ?? []
                this.dataRequest.otherDetailedIndustry = mapData.data.otherDetailedIndustry ?? ''
                this.dataRequest.salesInvoiceImage = mapData.data.salesInvoiceImage ?? []
                this.salesInvoiceImage = mapData.data.salesInvoiceImage ?? []
                this.dataRequest.typeOffer = mapData.data.typeOffer ?? ''
                this.dataRequest.websiteLink = mapData.data.websiteLink ?? ''
                this.dataRequest.revenue = mapData.data.revenue
                  ? this.formatNumberString(mapData.data.revenue)
                  : ''
                this.dataRequest.operationNote = mapData.data.operationNote ?? ''
                this.dataRequest.regionDirectorNote = mapData.data.regionDirectorNote ?? ''
                this.dataRequest.code = mapData.data.code ?? ''
                this.dataRequest.status = mapData.data.status ?? ''
                this.dataRequest.createByEmail = mapData.data.createByEmail ?? ''
                this.dataRequest.createAt = mapData.data.createAt ?? ''
                this.dataRequest.brandOwnership = mapData.data.brandOwnership ?? ''
                this.dataRequest.bankAccountType = mapData.data.bankAccountType ?? ''

                this.$refs.historyActionRef?.show(this.dataRequest.id)
                this.$refs.ticketInfoRef?.show(this.dataRequest, this.merchantSelected)
              }
            } else {
              this.showFailMx(response.message)
            }
          } catch (e) {
            this.showFailMx(e.message ?? e)
          } finally {
            this.showLoading = false
          }
        }
      },
      syncFileIdCardImage(files) {
        this.idCardImage = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.idCardImage = files
        } else {
          delete this.dataRequest.idCardImage
        }
      },
      syncFileBusinessLicenseImage(files) {
        this.businessLicenseImage = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.businessLicenseImage = files
        } else {
          delete this.dataRequest.businessLicenseImage
        }
      },
      syncFileBrandRelatedImage(files) {
        this.brandRelatedImage = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.brandRelatedImage = files
        } else {
          delete this.dataRequest.brandRelatedImage
        }
      },
      syncFileOperatingLicense(files) {
        this.operatingLicense = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.operatingLicense = files
        } else {
          delete this.dataRequest.operatingLicense
        }
      },
      syncFileSalesInvoiceImage(files) {
        this.salesInvoiceImage = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.salesInvoiceImage = files
        } else {
          delete this.dataRequest.salesInvoiceImage
        }
      },
      syncFileAdditionalImg(files) {
        this.additionalImg = files
        if (Object.keys(files).length > 0) {
          this.dataRequest.additionalImg = files
        } else {
          delete this.dataRequest.additionalImg
        }
      },
      syncFileRelatedImage(files, key, index) {
        this.relatedImage[index] = files

        if (files.length === 0) {
          this.relatedImage.splice(index, 1)
        }
      },
      async onSelectMerchant(mc) {
        this.merchantSelected = mc && mc.mposMerchantId ? mc : { merchantName: '' }
        this.dataRequest.merchantMposId = mc && mc.mposMerchantId ? mc.mposMerchantId : ''
        if (this.dataRequest.merchantMposId == '') {
          this.showFailMx('MC chưa tồn tại trong MPOS. Vui lòng thực hiện luồng tạo hợp đồng')
          return
        }

        this.getContractLink()

        this.dataRequest.industry = mc && mc.mcc ? mc.mcc : ''
        this.selectedBusiness()
        this.dataRequest.detailedIndustry = mc && mc.mccDetail ? mc.mccDetail : ''
        this.dataRequest.otherDetailedIndustry = mc && mc.mccDetailOther ? mc.mccDetailOther : ''
        if (mc && mc.merchantBusinessAreas && mc.merchantBusinessAreas.length > 0) {
          this.dataRequest.businessAddress = await mc.merchantBusinessAreas.reduce(
            async (acc, current) => {
              const param = {
                address: current.areaAddress ? current.areaAddress : '',
                districtId: current.areaDistrictCode ? current.areaDistrictCode : '',
                images: current.areaUrl ? current.areaUrl : [],
                name: current.areaName ? current.areaName : '',
                provinceId: current.areaCityCode ? current.areaCityCode : '',
                regionId: '',
              }

              await this.getDistrict(param.provinceId)

              if (param.images.length > 0) {
                this.relatedImage.push(param.images)
              }

              ;(await acc).push(param)

              return acc
            },
            []
          )
        }

        this.dataRequest.brand = mc && mc.brand ? mc.brand : ''
        this.dataRequest.websiteLink = mc && mc.website ? mc.website : ''
        this.dataRequest.businessForm = mc && mc.businessField ? mc.businessField : ''
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data ? data.data : []
              this.systemConfig = {
                businessFields: config.businessFields ? this.mapData(config.businessFields) : [],
                businessField: config.businessField
                  ? config.businessField.map(e => ({ id: e, text: e }))
                  : [],
                posBankIssuer: config.posBankIssuer
                  ? this.mapData(config.posBankIssuer, 'code', 'code')
                  : [],
                baseMccDetail: config.mccDetail ? config.mccDetail : [],
              }
            }
          })
          .catch(error => this.showFailMx(error.message ?? error))
      },
      selectedBusiness() {
        const mapData = this.systemConfig.baseMccDetail.find(
          items => items.code == this.dataRequest.industry
        )
        if (mapData) {
          this.optionBusinessDetail = mapData.detail
            ? mapData.detail.reduce((acc, current) => {
                acc.push({ id: current, text: current })
                return acc
              }, [])
            : []
        }
      },
      addBusinessStore() {
        const param = {
          address: '',
          districtId: '',
          images: [],
          name: '',
          provinceId: '',
          regionId: '',
        }

        this.dataRequest.businessAddress.push(param)
      },
      deleteBusinessStore(index) {
        this.dataRequest.businessAddress.splice(index, 1)
        this.relatedImage.splice(index, 1)
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', `merchant/${this.merchantSelected.customerId}/files`)
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else {
          if (item.url) {
            return { urlFile: item.url }
          }

          return { urlFile: item }
        }
      },
      async getContractLink() {
        try {
          this.showLoading = true
          const params = {
            page: 1,
            limit: 15,
            customerId: this.merchantSelected.customerId ? this.merchantSelected.customerId : 1,
            groupService: 'PAYMENT',
            serviceTypes: ['MPOS'],
          }
          const response = await ContractService.getListContract(params)
          if (response.success) {
            const mapData = response.data
            if (mapData.contractList && mapData.contractList.length > 0) {
              this.contractHistoryOne = mapData.contractList[0] ?? {}
            }
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      openLinkContract() {
        if (Object.keys(this.contractHistoryOne).length > 0) {
          const contract = this.contractHistoryOne

          if (contract.groupService === 'SELL') {
            if (contract.formContract === 'E_CONTRACT') {
              window.open(`/sales-manager/detail/${encodeURIComponent(contract.id)}`, '_blank')
            } else {
              window.open(
                `/sales-manager/detail-paper/${encodeURIComponent(contract.id)}`,
                '_blank'
              )
            }
          } else {
            if (contract.formContract === 'E_CONTRACT') {
              window.open(`/contract-detail-ecommerce/${encodeURIComponent(contract.id)}`, '_blank')
            } else {
              window.open(`/contract-detail-paper/${encodeURIComponent(contract.id)}`, '_blank')
            }
          }
        } else {
          this.showFailMx('Không có hợp đồng')
        }
      },
      updateRevenue() {
        this.dataRequest.revenue = this.formatNumberString(this.dataRequest.revenue)
      },
      updateNumberOfStore() {
        this.dataRequest.numberOfStore = this.formatNumber(this.dataRequest.numberOfStore)
      },
      async fetchDataMerchantStepTwo() {
        const customerId = this.$route.query.merchantId ?? ''
        if (customerId) {
          try {
            const response = await MerchantService.merchantDetail({
              customerId,
            })
            if (response.success) {
              this.dataRequest.typeOffer = this.$route.query.typeOffer ?? ''
              this.onSelectMerchant(response.data)
            }
          } catch (error) {
            this.showFailMx(error.message ?? error)
          }
        }
      },
      resetData() {
        this.dataRequest = {
          id: this.$route.params.id ?? '',
          informAt: {},
          merchantMposId: '',
          additionalStatus: 'NO_ADDITIONAL_INFO_NEEDED',
          businessAddress: [],
        }
        this.merchantSelected = {
          merchantName: '',
        }
      },
      async getCity() {
        await ContractService.getAllCity({}).then(response => {
          if (response.success) {
            this.dataCity = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },
      async getDistrict(cityCode, index) {
        this.checkGetDistrict = false
        if (this.dataRequest.businessAddress[index])
          this.dataRequest.businessAddress[index].districtId = ''
        if (this.dataDistrict[cityCode]) return (this.checkGetDistrict = true)

        await ContractService.getDistictByCode({ cityCode }).then(response => {
          if (response.success) {
            this.dataDistrict[cityCode] = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.checkGetDistrict = true
          }
        })
      },
    },
  }
</script>
<style></style>
